const form = document.getElementById('age-gate-form');

if (form) {
    const inputs = form.querySelectorAll('.age-gate__input');
    const submitBtn = form.querySelector('.age-gate__btn');

    const updateButton = () => {
        const day = inputs[0].value.trim();
        const month = inputs[1].value.trim();
        const year = inputs[2].value.trim();

        submitBtn.disabled = !(day.length >= 1 && month.length >= 1 && year.length === 4);
    };

    inputs.forEach((input, index) => {
        input.addEventListener('input', () => {
            input.value = input.value.replace(/\D/g, '');
            updateButton();

            if (index < 2 && input.value.length === 2) {
                inputs[index + 1].focus();
            }
        });
    });
}
